import React, { useState } from 'react';
import { Typography, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/StarRounded';
import ShareIcon from '@mui/icons-material/Share';

import { Counter } from 'components/SlideGroups/components/Counter';
import { YELLOW_MARKED } from 'components/utilities/constants';
import { useDefaultSlideGroupHeaderStyles } from 'components/SlideGroups/utilities/styles';
import { TextWithLimitedWidth } from 'components/SlideGroups/components/TextWithLimitedWidth';
import { ShareSlideGroupModal } from 'components/Modals/ShareSlideGroupModal/ShareSlideGroupModal';

export const FavoriteSlideGroupHeader = ({ slideGroup }) => {
  const { classes } = useDefaultSlideGroupHeaderStyles();
  const [isShareModalVisible, setIsShareModalVisible] = useState(false);

  return (
    <>
      <Box className={classes.header}>
        {/* LEFT — name + star (same typography as dynamic header) */}
        <Box className={classes.leftSection}>
          <TextWithLimitedWidth
            value="my favorites"
            textClass={classes.headerText}
            containerClass={classes.headerTextContainer}
          />
          <StarIcon htmlColor={YELLOW_MARKED} fontSize="small" />
        </Box>

        {/* RIGHT — Share icon + SLIDES + counter */}
        <Box
          className={classes.row}
          sx={{ ml: 'auto', mr: '38px' }} // ← add 48 px buffer to match missing icons
        >
          <Tooltip disableInteractive title="Share group" placement="bottom">
            <ShareIcon
              className={classes.actionIcon} // keeps default .5 rem left margin
              onClick={() => setIsShareModalVisible(true)}
            />
          </Tooltip>

          <Typography variant="h6" gutterBottom className={classes.slidesLabel}>
            SLIDES
          </Typography>
          <Counter count={slideGroup.slides.length} />
        </Box>
      </Box>

      {isShareModalVisible && (
        <ShareSlideGroupModal
          onClose={() => setIsShareModalVisible(false)}
          slideGroup={slideGroup}
        />
      )}
    </>
  );
};
